///////////////封装axios////////////////
import axios from 'axios';
import qs from 'qs';
import router from '../router'

import store from '@/store/index'
//loading
import { Loading } from 'element-ui';
import { Message } from 'element-ui';

// 1.环境的切换

// axios.defaults.baseURL = 'http://172.16.9.72:8086/'  //测试内网
axios.defaults.baseURL = 'http://leshanfx.tiance.cn/api/'  //正式
// axios.defaults.baseURL = 'http://123.60.72.41:8085/';  //  测试外网
// axios.defaults.baseURL = 'http://172.16.2.242:8081/';  //  本地钦松
// axios.defaults.baseURL = 'http://pv8rc6.natappfree.cc/'

// 2.设置请求超时
axios.defaults.timeout = 120000;

// 3.设置post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF8';

// 4. 请求拦截(登录才能访问)
// vuex中存储登录状态
var loadingInstance;
axios.interceptors.request.use(
    config => {
        // 每次发送请求之前判断vuex中是否存在token        
        // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断 
        const token = store.state.token;
        token && (config.headers.Authorization = token);
        // （...加载框loading）
        loadingInstance = Loading.service({
            fullscreen: true,
            background: 'rgba(0,0,0,0)',
            lock: true,
            text: '正在加载...',
        });
        return config;

    },
    error => {
        // (...隐藏loading)
        loadingInstance.close();
        return error;
    })

// 5.响应拦截
axios.interceptors.response.use(
    response => {
        // debugger;
        // console.log(response)
        //(...隐藏加载框loading)

        loadingInstance.close();
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
        // 否则的话抛出错误
        if (response.data.status === '200') {
            return Promise.resolve(response);
        } else if (response.data.status == '418') {
            Message({ message: response.data.msg });
            // console.log(response.msg)
            setTimeout(() => {
                router.replace({
                    path: '/login',
                    query: {
                        redirect: router.currentRoute.fullPath
                    }
                });
            }, 1000);
        } else if(response.data.status == '408') {
            Message({ message: response.data.msg });
            setTimeout(() => {
                router.replace({
                    path: '/login',
                    query: {
                        redirect: router.currentRoute.fullPath
                    }
                });
            }, 1000);
        }
        else {
            Message({ message: response.data.msg });
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码    
    // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    // 下面列举几个常见的操作（没登录或登录过期），其他需求可自行扩展
    error => {
        //(...隐藏加载框loading)
        loadingInstance.close();
        if (error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。                
                case 401:
                    router.replace({
                        path: '/login',
                        query: {
                            redirect: router.currentRoute.fullPath
                        }
                    });
                    break;

                // 418 token过期
                // 登录过期对用户进行提示
                // 清除本地token和清空vuex中token对象
                // 跳转登录页面                
                case 408:
                    Message({ message: error.response.msg });

                    // 清除token
                    localStorage.removeItem('token');
                    // store.commit('loginSuccess', null);
                    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面 
                    setTimeout(() => {
                        router.replace({
                            path: '/login',
                            query: {
                                redirect: router.currentRoute.fullPath
                            }
                        });
                    }, 1000);
                    break;

                case 417:
                    Message({ message: error.response.msg });
                    break;
                // 404请求不存在
                case 404:
                    // vant组件
                    Toast({
                        message: '网络请求不存在',
                        duration: 1500,
                        forbidClick: true
                    });
                    break;
                // 其他错误，直接抛出错误提示
                default:
                    // vant组件
                    Toast({
                        message: error.response.data.message,
                        duration: 1500,
                        forbidClick: true
                    });
            }
            return Promise.reject(error.response);
        }
    }
)

// 6.封装get和post方法
// get函数 两个参数，第一个 请求的URL地址，第二个 携带的请求参数
// get返回的是一个promise对象
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data)
        })
    })
};
export function fetchGet1(url, params) {
    return axios({
      url,
      method: 'get',
      params:{
        ...params,
        token: localStorage.getItem('token'),
        uid: localStorage.getItem('uid'),
    },
      header: {
        headers: { 'Content-Type': 'application/json' }
      },

    })
  };
export function GET(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: {
                ...params,
                token: localStorage.getItem('token'),
                uid: localStorage.getItem('uid'),
            },
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data)
        })
    })
};
export function deletefun(url, params) {
    return new Promise((resolve, reject) => {
        axios.delete(url, {
            params: {
                ...params,
                token: localStorage.getItem('token'),
                uid: localStorage.getItem('uid'),
            },
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data)
        })
    })
};
// post方法 通过qs模块来序列化参数
export function post(url, params,isToken=true) {
    let data = {
        ...params,
    }
    if(isToken){
        data.token =  localStorage.getItem('token')
    }
    return new Promise((resolve, reject) => {
        axios.post(url, qs.stringify(data))
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
// api.js中统一接口
// api.js中统一接口管理


